import "core-js/modules/es.array.concat";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @description: '定义上传公共类'
 * @author: dongtao
 * @date: 2020-09-01 15:50:46
 * @version: V1.0.0
*/
import { Message } from 'hui';
import Token from '@/config/token';
import store from '@/store/index';

var UploadConfig = /*#__PURE__*/function () {
  function UploadConfig() {
    _classCallCheck(this, UploadConfig);
  }

  _createClass(UploadConfig, [{
    key: "beforeUpload",
    // 上传前判断文件大小
    value: function beforeUpload(file) {
      var isMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      console.log('文件大小', file.size);
      var isLt0B = file.size > 0;

      if (!isLt0B && isMessage && document.getElementsByClassName('el-message').length === 0) {
        Message('上传文件的大小不能为空');
      }

      var isLt2M = file.size < store.getters.maxFileSize;

      if (!isLt2M && isMessage && document.getElementsByClassName('el-message').length === 0) {
        Message("\u4E0A\u4F20\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 ".concat(this.bytesToSize(store.getters.maxFileSize)));
      }

      return isLt0B && isLt2M;
    } // 文件大小中文描述

  }, {
    key: "bytesToSize",
    value: function bytesToSize(bytes) {
      if (bytes === 0) return '0 B';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return "".concat(bytes / Math.pow(k, i), " ").concat(sizes[i]); // toPrecision(3) 后面保留一位小数，如1.0GB
      // return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    }
    /**
     * @description 上传速度
     * @params
     *  loaded    number  当前已加载字节大小
     *  timeStamp number  当前时间戳
     *  startTime number  上一次加载的时间戳
     * @returns  String 速度 M/s
    */

  }, {
    key: "computeVelocity",
    value: function computeVelocity(loaded, timeStamp, startTime) {
      var percentSize = parseFloat((loaded * 9.5367431640625e-7).toFixed(2));
      var percentTimeStamp = (timeStamp - startTime) / 1000;
      if (loaded === 0) return '0.00M/s';
      if (loaded < 10485.76) return '0.01M/s';
      return "".concat((percentSize / percentTimeStamp).toFixed(2), "M/s");
    }
    /**
     * @description 文件大小转换
     * @params
     *  size     number  文件大小 byte
     * @returns  String  文件大小 Mb
    */

  }, {
    key: "countSize",
    value: function countSize(base) {
      var size = +base || 0; // const BYTE = 1

      var KB = 1024;
      var MB = 1048576;
      var GB = 1073741824; // const size = +(loaded * 9.5367431640625e-7).toFixed(2)

      if (size < KB) {
        return "".concat(size.toFixed(2), "B");
      }

      if (size < MB) {
        return "".concat((size / KB).toFixed(2), "KB");
      }

      if (size < GB) {
        return "".concat((size / MB).toFixed(2), "MB");
      }

      return "".concat((size / GB).toFixed(2), "GB"); // const finalSize: string = (size * 9.5367431640625e-7).toFixed(2)
      // if (size === 0) return '0.00'
      // if (size < 10485.76) return '0.01'
      // return finalSize
    }
    /**
     * @description upload http-request
     * @params option Object  接口参数
     * @params request Function 接口函数
     * @returns Promise
    */

  }, {
    key: "httpRequest",
    value: function httpRequest(option, request) {
      return new Promise(function (resolve, reject) {
        var formData = new FormData(); // eslint-disable-next-line guard-for-in

        for (var key in option) {
          formData.append(key, option[key]);
        }

        request(formData).then(function (uploadRes) {
          resolve(uploadRes);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: "headers",
    get: function get() {
      return {
        Authorization: Token.getToken(),
        cmAuthorization: Token.getCMToken()
      };
    }
  }]);

  return UploadConfig;
}();

export { UploadConfig as default };